<script>
import InputRut from "../InputRut.vue";
import InputRegion from "../InputRegion.vue";
export default {
  components: { InputRut, InputRegion },
  name: "FormUsuario",

  props: {
    despacho: Object,
    postInformacionGeneral: Function,
    informacionGeneral: Object,
    editar: Function,
    estados: Object,
  },
  data() {
    return {
      //importacion
      nombre: "",
      nombre_transporte: "",
      numero_manifiesto: "",
      cliente_id: 0,
      fecha_eta: "",
      tipo_carga: "",
      caracteristicas_carga: "",
      transporte: "",
      correo_transporte: "",

      //exportacion
      estado_presentacion_matriz: "",
      dus_primer_envio: "",
      dus_legalizado: "",
      aduana_id: "",
      prorroga: false,

      options: [{ text: "Prorroga", value: true }],

      pantalla: false,
    };
  },
  mounted() {
    if (screen.width <= 660) this.pantalla = false;
    else this.pantalla = true;
  },
  methods: {
    cambiarRut(value) {
      this.cliente_rut = value;
    },
    cambiarRutTransporte(value) {
      this.transporte = value;
    },
  },
};
</script>

<template>
  <div class="flex flex-col">
      <!--REFERENCIA CLIENTE -->
      <div>
      
      <div 
        class="grid grid-cols-5 p-2 gap-4" 
        v-if="despacho.ref_cliente && estados.ref_cliente">
        <div class="flex flex-row items-center text-left col-span-2">
          Referencia Cliente
        </div>
        <div class="flex flex-row items-center justify-end col-span-2">
          {{ despacho.ref_cliente ?? '-'}}
        </div>
        <div class="flex flex-row items-center justify-end text-right col-span-1">
          <button
            v-if="pantalla == true"
            class="btn-principal"
            @click="editar('pedidor_exportacion', 'ref_cliente')"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="editar('pedidor_exportacion', 'ref_cliente')"
            class="btn-principal-chico"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>
      </div>
      <div v-else class="grid grid-cols-2 gap-4 p-4">
        <div>
            <label>Referencia Cliente</label>
            <input
              v-model="ref_cliente"
              :placeholder="despacho.ref_cliente"
              required
            >
            </input>
        </div>
        <div class="flex flex-row items-end gap-4">
          <button
            class="btn-principal"
            type="button"
            @click="
              editar('pedidor_exportacion', 'ref_cliente', true, {
                ref_cliente: ref_cliente,
              })
            "
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="editar('pedidor_exportacion', 'ref_cliente')"
          >
            Cancelar
          </button>
        </div>
    
      </div>
    </div>
      
      <!--ESTADO PRESENTACION MATRIZ -->
      <div>
      <div
        class="grid grid-cols-5 p-2 gap-4" 
        v-if="
          despacho.tipo.estado_presentacion_matriz &&
          estados.estado_presentacion_matriz
        "
      >
        <div class="flex flex-row items-center text-left col-span-2">
          Estado Presentación Matriz
        </div>

        <div class="flex flex-row items-center justify-end col-span-2">
            {{ despacho.tipo.estado_presentacion_matriz ?? '-'}}
        </div>
        <div class="flex flex-row items-center justify-end text-right col-span-1">
          <button
            v-if="pantalla == true"
            @click="editar('pedidor_exportacion', 'estado_presentacion_matriz')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="editar('pedidor_exportacion', 'estado_presentacion_matriz')"
            class="btn-principal"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>
      </div>
      <div v-else class="grid grid-cols-2 gap-4 p-4">
        <div>
          <label>Estado Presentación Matriz</label>
          <select
            id="importancia-select"
            v-model="estado_presentacion_matriz"
            required
          >
            <option value="0" disabled>
              Selecciona el Estado Presentación Matriz
            </option>
            <option
              :key="index"
              v-for="(
                estadoPresentacion, index
              ) in informacionGeneral.estado_presentacion_matriz"
              :value="estadoPresentacion"
            >
              {{ estadoPresentacion }}
            </option>
          </select>
        </div>
      
        <div class="flex flex-row items-end gap-4">
          <button
            class="btn-principal"
            type="button"
            @click="
              editar(
                'pedidor_exportacion',
                'estado_presentacion_matriz',
                true,
                { estado_presentacion_matriz: estado_presentacion_matriz }
              )
            "
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="
              editar('pedidor_exportacion', 'estado_presentacion_matriz')
            "
          >
            Cancelar
          </button>
        </div>        
      </div>
    </div>

      <!--ESTADO PRESENTACION MATRIZ -->
      <div>
      <div
        class="grid grid-cols-5 p-2 gap-4" 
        v-if="despacho.tipo.dus_primer_envio && estados.dus_primer_envio">
        <div class="flex flex-row items-center text-left col-span-2">
          <p>Dus 1er Envio</p>
        </div>
        <div class="flex flex-row items-center justify-end col-span-2">          
            {{ despacho.tipo?.dus_primer_envio ?? '-' }}          
        </div>
        <div class="flex flex-row items-center justify-end text-right col-span-1">
          <button
            v-if="pantalla == true"
            @click="editar('pedidor_exportacion', 'dus_primer_envio')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="editar('pedidor_exportacion', 'dus_primer_envio')"
            class="btn-principal-chico"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>
      </div>
      <div v-else class="grid grid-cols-2 gap-4 p-4">
        <div>
          <label>Dus 1er Envio</label>
            <select
              id="importancia-select"
              v-model="dus_primer_envio"
              required
            >
              <option value="0" disabled>
                Selecciona el Estado Dus 1er Envio
              </option>
              <option
                :key="index"
                v-for="(
                  estadoDus1erEnvio, index
                ) in informacionGeneral.dus_primer_envio"
                :value="estadoDus1erEnvio"
              >
                {{ estadoDus1erEnvio }}
              </option>
            </select>
        </div>
        <div class="flex flex-row items-end gap-4">
          <button
            class="btn-principal"
            type="button"
            @click="
              editar('pedidor_exportacion', 'dus_primer_envio', true, {
                dus_primer_envio: dus_primer_envio,
              })
            "
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="editar('pedidor_exportacion', 'dus_primer_envio')"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>

      <!--ESTADO PRESENTACION MATRIZ -->
      <div>
      <div 
        class="grid grid-cols-5 p-2 gap-4" 
        v-if="despacho.tipo.dus_legalizado && estados.dus_legalizado">
        <div class="flex flex-row items-center text-left col-span-2">
          Dus Legalizado
        </div>
        <div class="flex flex-row items-center justify-end col-span-2">
            {{ despacho.tipo.dus_legalizado ?? '-'}}
        </div>

        <div class="flex flex-row items-center justify-end text-right col-span-1">
          <button
            v-if="pantalla == true"
            @click="editar('pedidor_exportacion', 'dus_legalizado')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="editar('pedidor_exportacion', 'dus_legalizado')"
            class="btn-principal-chico"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>
      </div>
      <div v-else class="grid grid-cols-2 gap-4 p-4">
        <div>
          <label>Dus Legalizado</label>
          <select
            id="importancia-select"
            v-model="dus_legalizado"
            required
          >
            <option value="0" disabled>
              Selecciona el Estado Dus Legalizado
            </option>
            <option
              :key="index"
              v-for="(
                estadoDusLegalizado, index
              ) in informacionGeneral.dus_legalizado"
              :value="estadoDusLegalizado"
            >
              {{ estadoDusLegalizado }}
            </option>
          </select>
        </div>
        <div class="flex flex-row items-end gap-4">
          <button
            class="btn-principal"
            type="button"
            @click="
              editar('pedidor_exportacion', 'dus_legalizado', true, {
                dus_legalizado: dus_legalizado,
              })
            "
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="editar('pedidor_exportacion', 'dus_legalizado')"
          >
            Cancelar
          </button>
        </div>
          
      </div>
    </div>
      
      <div>
      <div 
        class="grid grid-cols-5 p-2 gap-4"  
        v-if="estados.prorroga">
        <div class="flex flex-row items-center text-left col-span-2">
          Requiere Prorroga
        </div>
        <div class="flex flex-row items-center justify-end col-span-2">
          {{ despacho.tipo.prorroga ? despacho.tipo.prorroga == 1 ? 'Si' : 'No' : '-'}}        
        </div>

        <div class="flex flex-row items-center justify-end text-right col-span-1">
          <button
            v-if="pantalla == true"
            @click="editar('pedidor_exportacion', 'prorroga')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="editar('pedidor_exportacion', 'prorroga')"
            class="btn-principal-chico"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>
      </div>
      <div v-else class="grid grid-cols-2 gap-4 p-4">      
          <div class="text-left">
          <label>Prorroga</label>
            <select id="importancia-select" v-model="prorroga" required>
              <option value="0" disabled>Seleccione una opción</option>
              <option :value="false">No</option>
              <option :value="true">Si</option>
            </select>
          </div>

          <div class="flex flex-row items-end gap-4">
            <button
              class="btn-principal"
              type="button"
              @click="
                editar('pedidor_exportacion', 'prorroga', true, {
                  prorroga: prorroga,
                })
              "
            >
              Guardar
            </button>
            <button
              class="btn-secundario"
              type="button"
              @click="editar('pedidor_exportacion', 'prorroga')"
            >
              Cancelar
            </button>
          </div>    
      </div>
    </div>
      
    <div>
    <div 
      class="grid grid-cols-5 p-2 gap-4"  
      v-if="despacho.tipo.aduana && estados.aduana">
      <div class="flex flex-row items-center text-left col-span-2">
        Aduana
      </div>
      <div class="flex flex-row items-center justify-end col-span-2">
        {{ despacho.tipo?.aduana?.nombre ?? '-' }}
      </div>
      <div class="flex flex-row items-center justify-end text-right col-span-1">
        <button
          v-if="pantalla == true"
          @click="editar('pedidor_exportacion', 'aduana')"
          class="btn-principal"
        >
          Editar
          <fas :icon="['fas', 'edit']" />
        </button>
        <button
          v-if="pantalla == false"
          @click="editar('pedidor_exportacion', 'aduana')"
          class="btn-principal"
        >
          <inline-svg
            class="icono-titulo"
            src="../../assets/images/EditarAzul.svg"
            title="My Image"
          />
        </button>
      </div>
    </div>
    <div v-else class="grid grid-cols-2 gap-4 p-4">      
      <div>          
        <label>Aduana</label>
        <select id="importancia-select" v-model="aduana_id" required>
          <option value="0" disabled>Selecciona una Aduana</option>
          <option
            :key="index"
            v-for="(aduana, index) in informacionGeneral.aduana"
            :value="aduana.id"
          >
            {{ aduana.nombre }}
          </option>
        </select>          
      </div>
      <div class="flex flex-row items-end gap-4">
        <button
          class="btn-principal"
          type="button"
          @click="
            editar('pedidor_exportacion', 'aduana', true, {
              aduanas_id: aduana_id,
            })
          "
        >
          Guardar
        </button>
        <button
          class="btn-secundario"
          type="button"
          @click="editar('pedidor_exportacion', 'aduana')"
        >
          Cancelar
        </button>
      </div>
    </div>
    </div>

    <div>
    <div
    class="grid grid-cols-5 p-2 gap-4"  
      v-if="despacho.tipo.nombre_transporte && estados.nombre_transporte"
    >
      <div class="flex flex-row items-center text-left col-span-2">
        Medio de Transporte
      </div>
      <div class="flex flex-row items-center justify-end col-span-2">
          {{ despacho.tipo?.nombre_transporte ?? '-'}}          
      </div>
      <div class="flex flex-row items-center justify-end text-right col-span-1">
        <button
          v-if="pantalla == true"
          @click="editar('pedidor_exportacion', 'nombre_transporte')"
          class="btn-principal"
        >
          Editar
          <fas :icon="['fas', 'edit']" />
        </button>
        <button
          v-if="pantalla == false"
          @click="editar('pedidor_exportacion', 'nombre_transporte')"
          class="btn-principal-chico"
        >
          <inline-svg
            class="icono-titulo"
            src="../../assets/images/EditarAzul.svg"
            title="My Image"
          />
        </button>
      </div>
      <div
        v-if="despacho.tipo.nombre_nave"
        class="text-left"
      >
        Nombre de Nave
      </div>
      <div>
        {{ despacho.tipo?.nombre_nave ?? '-'}}
      </div>
    </div>
    <div v-else class="grid grid-cols-2 gap-4 p-4">
      <div>
        <label>Medio de Transporte</label>
          <select
            id="importancia-select"
            v-model="nombre_transporte"
            required
          >
            <option value="0" disabled>
              Selecciona el Medio de Transporte
            </option>
            <option
              :key="index"
              v-for="(
                nombreTrasporte, index
              ) in informacionGeneral.nombre_transporte"
              :value="nombreTrasporte"
            >
              {{ nombreTrasporte }}
            </option>
          </select>
      </div>
      <div class="flex flex-row items-end gap-4">
        <button
          class="btn-principal"
          type="button"
          @click="
            editar('pedidor_exportacion', 'nombre_transporte', true, {
              nombre_transporte: nombre_transporte,
            })
          "
        >
          Guardar
        </button>
        <button
          class="btn-secundario"
          type="button"
          @click="editar('pedidor_exportacion', 'nombre_transporte')"
        >
          Cancelar
        </button>
      </div>
    </div>
    </div>
  </div>
</template>
